import { EquipmentGroupService } from "@/common/api.service"
import { FETCH_EQUIPMENT_GROUP_DATA, FETCH_EQUIPMENT_GROUP_INDIVIDUAL_DATA, ADD_EQUIPMENT_GROUP_DATA, UPDATE_EQUIPMENT_GROUP_DATA, DELETE_EQUIPMENT_GROUP_DATA, RESET_STATE } from "./actions.type"
import { SET_EQUIPMENT_GROUP_DATA, SET_ERROR_EQUIPMENT_GROUP, SET_EQUIPMENT_GROUP_INDIVIDUAL_DATA, STATE_RESET  } from "./mutations.type"

const initialState = () => {
    return {
        equipmentgroupdata: [],
        individualequipmentgroup: [],
        equipmentgrouperrors: null,
    }
}

let state = initialState()

const getters = {
    equipmentgroupdata(state) {
        return state.equipmentgroupdata
    },
    individualequipmentgroup(state) {
        return state.individualequipmentgroup
    }
}

const actions = {
    async [FETCH_EQUIPMENT_GROUP_DATA](context, slug) {
        const { data } = await EquipmentGroupService.get(slug)
        context.commit(SET_EQUIPMENT_GROUP_DATA, data.data)
        return data;
    },
    async [FETCH_EQUIPMENT_GROUP_INDIVIDUAL_DATA](context, slug) {
        const { data } = await EquipmentGroupService.get(slug)
        context.commit(SET_EQUIPMENT_GROUP_INDIVIDUAL_DATA, data.data)
        return data;
    },  
    async [ADD_EQUIPMENT_GROUP_DATA](context, payload) {
        return await EquipmentGroupService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_EQUIPMENT_GROUP, error.response.data.errors)
        });
    },     
    async [UPDATE_EQUIPMENT_GROUP_DATA](context, payload) {
        return await EquipmentGroupService.update(payload, (payload.get('equip_group_id')?payload.get('equip_group_id'):'' ))
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_EQUIPMENT_GROUP, error.response.data.errors)
        });
    },  
    async [DELETE_EQUIPMENT_GROUP_DATA] (context, id) {
        return await EquipmentGroupService.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_EQUIPMENT_GROUP, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_EQUIPMENT_GROUP](state, error) {
        state.equipmentgrouperrors = error
    },      
    [SET_EQUIPMENT_GROUP_DATA](state, equipmentgroupdata) {
        state.equipmentgroupdata = equipmentgroupdata
    },
    [SET_EQUIPMENT_GROUP_INDIVIDUAL_DATA](state, individualequipmentgroup) {
        state.individualequipmentgroup = individualequipmentgroup
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};